import {Droppable, Plugins} from '@shopify/draggable';

import SoundFx from '../../../components/SoundFx';

export default function CollidableSection() {
  const containerSelector = '.CubesFrame--idCollidable';
  const containers = document.querySelectorAll(containerSelector);
  const draggable = new Droppable(containers, {
    dropzone: '.Cube--typeDropzone',
    mirror: {
      appendTo: containerSelector,
    },
    collidables: `${containerSelector} .CollisionWall`,
    plugins: [Plugins.Collidable],
  });

  // --- Drag states --- //
  let canPlayOverSound = false;

  draggable.on('drag:start', () => {
    SoundFx.Single.play('cubeUp');
  });

  draggable.on('drag:over', () => {
    if (!canPlayOverSound) {
      return;
    }

    SoundFx.Single.play('cubeOver');
  });

  draggable.on('drag:out', () => {
    canPlayOverSound = true;
  });

  draggable.on('drag:stop', () => {
    SoundFx.Single.play('cubeDown');
    canPlayOverSound = false;
  });

  draggable.on('collidable:in', ({collidingElement}) => {
    SoundFx.Single.play('cubeCollide');
    collidingElement.classList.add('isColliding');
  });

  draggable.on('collidable:out', ({collidingElement}) => {
    collidingElement.classList.remove('isColliding');
  });

  return draggable;
}
